import api from "./axios";

// =========================================================
// LIST SCHOOLS
// =========================================================

export const getSchools = async (
  page = 1,
  limit = 10,
  search = "",
  filters = {}
) => {
  const response = await api.get("/schools", {
    params: {
      page,
      limit,
      search,

      // -----------------------------
      // FILTERS
      // -----------------------------

      status:
        filters.status || undefined,

      board:
        filters.board || undefined,

      schoolId:
        filters.schoolId || undefined,

      assignedEmployeeId:
        filters.assignedEmployeeId || undefined,

      countryId:
        filters.countryId || undefined,

      stateId:
        filters.stateId || undefined,

      districtId:
        filters.districtId || undefined,

      cityId:
        filters.cityId || undefined,

      territoryId:
        filters.territoryId || undefined,
    },
  });

  return response.data;
};


// =========================================================
// CREATE
// =========================================================

export const createSchool = async (data) => {
  const response = await api.post(
    "/schools",
    data
  );

  return response.data;
};


// =========================================================
// SINGLE
// =========================================================

export const getSchool = async (id) => {
  const response = await api.get(
    `/schools/${id}`
  );

  return response.data;
};


// =========================================================
// UPDATE
// =========================================================

export const updateSchool = async (
  id,
  data
) => {
  const response = await api.patch(
    `/schools/${id}`,
    data
  );

  return response.data;
};


// =========================================================
// DELETE / DEACTIVATE
// =========================================================

export const deleteSchool = async (id) => {
  const response = await api.delete(
    `/schools/${id}`
  );

  return response.data;
};


// =========================================================
// DUPLICATE CHECK
// =========================================================

export const checkSchoolDuplicate = async (
  data
) => {
  const response = await api.post(
    "/schools/duplicate-check",
    data
  );

  return response.data;
};


// =========================================================
// STATUS HISTORY
// =========================================================

export const getSchoolStatusHistory = async (
  id
) => {
  const response = await api.get(
    `/schools/${id}/status-history`
  );

  return response.data;
};


// =========================================================
// ACTIVE EMPLOYEES
// =========================================================

export const getSchoolAssignableEmployees =
  async () => {
    const response = await api.get(
      "/employees",
      {
        params: {
          page: 1,
          limit: 500,
          status: "active",
        },
      }
    );

    return response.data;
  };


// =========================================================
// ALL SCHOOLS FOR FILTER DROPDOWN
// =========================================================

export const getAllSchoolsForFilter =
  async () => {
    const response = await api.get(
      "/schools",
      {
        params: {
          page: 1,
          limit: 500,
        },
      }
    );

    return response.data;
  };


// =========================================================
// EXPORT SCHOOLS
//
// This uses the same /schools API and downloads
// the complete filtered result as CSV.
//
// It does NOT change the existing CRUD API flow.
// =========================================================

export const exportSchools = async (
  filters = {},
  search = ""
) => {
  const response = await api.get(
    "/schools",
    {
      params: {
        page: 1,
        limit: 10000,

        search,

        status:
          filters.status || undefined,

        board:
          filters.board || undefined,

        schoolId:
          filters.schoolId || undefined,

        assignedEmployeeId:
          filters.assignedEmployeeId ||
          undefined,

        countryId:
          filters.countryId || undefined,

        stateId:
          filters.stateId || undefined,

        districtId:
          filters.districtId || undefined,

        cityId:
          filters.cityId || undefined,

        territoryId:
          filters.territoryId || undefined,
      },
    }
  );

  return response.data;
};

export const importSchools = async (file) => {
  const formData = new FormData();

  formData.append("file", file);

  return api.post(
    "/schools/import",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// =========================================================
// NORMALIZE MASTER API RESPONSES
// =========================================================

const extractMasterRecords = (response, key) => {
  const body = response?.data;

  const candidates = [
    body?.data?.[key],
    body?.data?.items,
    body?.data?.records,
    body?.[key],
    body?.items,
    body?.records,
    body?.data,
  ];

  return candidates.find(Array.isArray) || [];
};

// =========================================================
// COUNTRIES
// =========================================================

export const getSchoolFilterCountries = async () => {
  const response = await api.get("/organization/countries", {
    params: {
      page: 1,
      limit: 1000,
      status: "active",
    },
  });

  return extractMasterRecords(response, "countries");
};

// =========================================================
// STATES BY COUNTRY
// =========================================================

export const getSchoolFilterStates = async (countryId) => {
  if (!countryId) return [];

  const response = await api.get(
    `/organization/countries/${countryId}/states`
  );

  return extractMasterRecords(response, "states");
};

// =========================================================
// DISTRICTS BY STATE
// =========================================================

export const getSchoolFilterDistricts = async (stateId) => {
  if (!stateId) return [];

  const response = await api.get(
    `/organization/states/${stateId}/districts`
  );

  return extractMasterRecords(response, "districts");
};

// =========================================================
// CITIES BY DISTRICT
// =========================================================

export const getSchoolFilterCities = async (districtId) => {
  if (!districtId) return [];

  const response = await api.get(
    `/organization/districts/${districtId}/cities`
  );

  return extractMasterRecords(response, "cities");
};